import Cookies from 'universal-cookie';
import { useCookiesProps, setCookieProps } from './useCookies.typed';

const useCookies = (props: useCookiesProps) => {
  const { name } = props;
  const cookies = new Cookies();

  function get() {
    return cookies.get(name);
  }

  function set(props: setCookieProps) {
    const { value, options } = props;

    cookies.set(name, value, options);
  }

  return { get, set };
};

export { useCookies };
